import { BaseCard, Grid, Input } from '@tiendanube/components';
import { CancelAndSaveButtons } from 'commons/components';
import Stack from 'commons/components/Stack';

interface ColombianFiscalDataFormSkeletonProps {
  onCancel: () => void;
}

function ColombianFiscalDataFormSkeleton({
  onCancel,
}: ColombianFiscalDataFormSkeletonProps): JSX.Element {
  return (
    <>
      <BaseCard>
        <BaseCard.Body>
          <Grid spacing="loose">
            <Grid.Row>
              {[
                <Grid.Column key={1}>
                  <Stack column align="stretch">
                    <Input.Skeleton />
                    <Input.Skeleton />
                    <Input.Skeleton />
                  </Stack>
                </Grid.Column>,
                <Grid.Column key={2}>
                  <Stack column align="stretch">
                    <Input.Skeleton />
                    <Stack>
                      <Input.Skeleton />
                      <Input.Skeleton />
                    </Stack>
                    <Input.Skeleton />
                  </Stack>
                </Grid.Column>,
              ]}
            </Grid.Row>
          </Grid>
        </BaseCard.Body>
      </BaseCard>
      <CancelAndSaveButtons
        onCancel={onCancel}
        onSave={() => null}
        isDisabled
      />
    </>
  );
}

export default ColombianFiscalDataFormSkeleton;
